const safeGet = (data, path, defaultValue) => {
  const p = path.split('.');
  return p.reduce((xs, x) => (xs && xs[x] !== undefined ? xs[x] : defaultValue), data);
};

export default safeGet;
